import { DeleteHostFamilyCommentsRequest } from '../../../lib/types/models/host-family/host-family'
import { IdsInput } from '../../../lib/types/utils'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function deleteHostFamilyOlComments(input: DeleteHostFamilyCommentsRequest) {
  const { ids, hostFamilyId } = input
  return restApiClient
    .url(
      encodeNestedObject<IdsInput>(
        constructApiUrl(API.hostFamilies.deleteHostFamilyOlComments.url, { hostFamilyId }),
        { ids }
      )
    )
    .delete()
}
